<template>
  <article class="content-wrap">
    <div>
      <p>{{this.message}}</p>
    </div>
  </article>
</template>


<script>
export default {
  name: "OAuth",

  data() {
    return {
      message: "로그인 성공",
    }
  },
  created() {
    const error = this.$route.query.error;
    if (error) {
      this.message = '로그인 실패';
      this.$notify.error('Failed', error)
    }


    setTimeout(() => {
      window.close();
    }, 30000);
  }
}
</script>